import React, { useContext } from 'react';
import { FaAddressBook, FaBuilding, FaPlus, FaSync } from 'react-icons/fa';
import HeaderReusable from '../../Global/HeaderContent';
import { SettingGeneralContext, SettingGeneralProvider } from '../../../context/settingGeneralContext';



export default function Header({
  isTabletOrMobile,
  query,
  setQuery,
  searchData,
  viewModalAdd,
  buttonRefresh
}) {
  return (
    <SettingGeneralProvider>
      <HeaderContent
        isTabletOrMobile={isTabletOrMobile}
        query={query}
        setQuery={setQuery}
        searchData={searchData}
        viewModalAdd={viewModalAdd}
        buttonRefresh={buttonRefresh}
      />
    </SettingGeneralProvider>
  )
}


function HeaderContent({
  isTabletOrMobile,
  query,
  setQuery,
  searchData,
  viewModalAdd,
  buttonRefresh
}) {
  return (
    <>
      <HeaderReusable
        title="List Lantai Gedung"
        icon={FaBuilding}
        isTabletOrMobile={false}
        query={query}
        setQuery={setQuery}
        searchData={searchData}
        onAdd={viewModalAdd}
        onRefresh={buttonRefresh}
        showAddButton={true}
        showRefreshButton={true}
      />
    </>
  )
}


